import { initTimeFormat } from "./utils/time-format";
import { initShare } from "./utils/share";
import { initAbTest } from "./utils/ab-tests";
import { initCopyToClipboard } from "./utils/clipboard";
import { initPricesExpand } from "./utils/pricing-expand";
import { initRating } from "./utils/rating";
import { initSLider } from "./components/slider";
import { initHeaderNav } from "./layout/header-nav";
import { initCountryAndLanguage } from "./layout/footer/country-language";
import { initFooterFixed } from "./layout/footer/footer-fixed";
import { initHomePageHeader } from "./layout/header/homepage-header";
import { initBadges } from "./pages/badges";
import { initContact } from "./pages/contact";
document.addEventListener("DOMContentLoaded", () => {
    const initializers = [
        //utils
        initTimeFormat,
        initTimeFormat,
        initShare,
        initAbTest,
        initCopyToClipboard,
        initFooterFixed,
        initPricesExpand,
        initRating,
        //Component
        initSLider,
        //Layout
        initHeaderNav,
        initCountryAndLanguage,
        initHomePageHeader,
        //Pages
        initBadges,
        initContact,
    ];
    initializers.forEach((fn) => {
        try {
            fn();
        }
        catch (error) {
            console.error(`❌ ${fn.name} failed:`, error);
        }
    });
});
